module.exports = __webpack_public_path__ + "img/cabo-verde-logo-icon.16672dbf.png";